import React from 'react';
import styles from './RingPlayer.module.css';

/**
 * Flower — 6-petal SVG that scales/recolors based on data-state set on
 * the parent wrapper. Pure presentation. Port of the prototype's
 * `.flower` SVG from Ring Player.html.
 *
 * Gradient IDs and inner class names are prefixed `rp*` so they don't
 * collide with other SVG content on the page. The wrapper div owns the
 * `top` position and the `data-state` attribute; CSS in
 * RingPlayer.module.css animates the petal transforms and halo based
 * on that attribute via `:global()` selectors.
 */
export default function Flower() {
  return (
    <svg
      className={styles.flower}
      viewBox="-50 -50 100 100"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="rpPetalGrad" cx="50%" cy="40%" r="60%">
          <stop offset="0%"  stopColor="#fbd6cb" />
          <stop offset="55%" stopColor="var(--rp-rose-300)" />
          <stop offset="100%" stopColor="var(--rp-rose-400)" />
        </radialGradient>
        <radialGradient id="rpPetalGradSage" cx="50%" cy="40%" r="60%">
          <stop offset="0%"  stopColor="#eaf2e4" />
          <stop offset="55%" stopColor="var(--rp-sage-300)" />
          <stop offset="100%" stopColor="var(--rp-sage-500)" />
        </radialGradient>
        <radialGradient id="rpPetalGradMauve" cx="50%" cy="40%" r="60%">
          <stop offset="0%"  stopColor="#f0dfe5" />
          <stop offset="55%" stopColor="var(--rp-mauve-300)" />
          <stop offset="100%" stopColor="var(--rp-mauve-500)" />
        </radialGradient>
      </defs>
      <g className="rp-petals">
        <ellipse className="rp-petal" cx="0" cy="-16" rx="9" ry="18" transform="rotate(0)" />
        <ellipse className="rp-petal" cx="0" cy="-16" rx="9" ry="18" transform="rotate(60)" />
        <ellipse className="rp-petal" cx="0" cy="-16" rx="9" ry="18" transform="rotate(120)" />
        <ellipse className="rp-petal" cx="0" cy="-16" rx="9" ry="18" transform="rotate(180)" />
        <ellipse className="rp-petal" cx="0" cy="-16" rx="9" ry="18" transform="rotate(240)" />
        <ellipse className="rp-petal" cx="0" cy="-16" rx="9" ry="18" transform="rotate(300)" />
      </g>
      <circle className="rp-flower-core" cx="0" cy="0" r="6" />
    </svg>
  );
}
